<cm-radio *ngFor="let option of options"
          class="radio-group-item"
          [checked]="value === option.id"
          [name]="name"
          [disabled]="isDisabled || option.disabled"
          (click)="!option.disabled && onRadioClick(option.id)">
  <span class="radio-group-item-label">{{option.name}}
    <i *ngIf="option.tooltip" class="fa fa-question-circle"
       [ngbTooltip]="option.tooltip"
       placement="right"></i></span>
  <ng-container [ngTemplateOutlet]="option.afterTpl"></ng-container>
</cm-radio>
